'use client'

import type { PropsWithChildren } from 'react'

/**
 * Auth0EnvLock (@dd3-tech/auth0-env-lock) se quedo en GitLab y no se migra a
 * GitHub, asi que este componente pasa a ser un passthrough: renderiza sus
 * children sin pedir autenticacion.
 *
 * El candado solo actuaba cuando NEXT_PUBLIC_STAGE === 'dev'; en prod y en
 * local ya renderizaba los children directamente. El efecto de quitarlo es
 * que el ambiente dev deja de exigir login de Auth0.
 *
 * Se conserva el componente con su misma firma para no tocar las 15 apps que
 * lo envuelven. La implementacion original esta en la historia de git.
 */

export enum ChannelType {
  WEB = 'web',
  MOBILE = 'mobile'
}

interface RequiredAuthDevStageProps {
  children: JSX.Element
  channel?: ChannelType.WEB | ChannelType.MOBILE
}

const RequiredAuthDevStage = ({
  children
}: PropsWithChildren<RequiredAuthDevStageProps>) => {
  return <>{children}</>
}

export default RequiredAuthDevStage
